(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "@thingsw/pitta-design-system", "@material-ui/core/styles", "@thingsw/pitta-modules", "../hoc/withStyleProvider"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("@thingsw/pitta-design-system"), require("@material-ui/core/styles"), require("@thingsw/pitta-modules"), require("../hoc/withStyleProvider"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.pittaDesignSystem, global.styles, global.pittaModules, global.withStyleProvider);
    global.LiveViewExceedModal = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _pittaDesignSystem, _styles, _pittaModules, _withStyleProvider) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.LiveViewExceedModal = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
  function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
  var useStyles = (0, _styles.makeStyles)(function (theme) {
    return {
      modalTitle: _defineProperty({
        minHeight: 16,
        padding: "25px 40px 0 24px"
      }, theme.breakpoints.up(_pittaModules.Webviewer.mobile), _objectSpread({}, theme.direction === "rtl" ? {
        padding: "25px 24px 0 13px"
      } : {
        padding: "25px 13px 0 24px"
      })),
      exceedModalRoot: {
        minWidth: 288,
        margin: 16
      },
      exceedModalContentDiv: {
        maxWidth: 450,
        padding: "16px 24px 57px"
      },
      // mantis - 10500, 모바일일 때 하단 버튼 가운데 정렬 (Leehj)
      btnWrap: _defineProperty({
        justifyContent: "center"
      }, theme.breakpoints.up(_pittaModules.Webviewer.mobile), {
        justifyContent: "flex-end"
      }),
      btn: {
        minWidth: 139,
        whiteSpace: "nowrap"
      }
    };
  });
  var LiveViewExceedModal = (0, _withStyleProvider.withStyleProvider)(function (_ref) {
    var open = _ref.open,
      onClose = _ref.onClose,
      onClickPositive = _ref.onClickPositive,
      onClickNegative = _ref.onClickNegative,
      t = _ref.t;
    var classes = useStyles();
    return /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Modal, {
      open: open,
      close: true,
      onClose: onClose,
      onClickPositive: onClickPositive,
      onClickNegative: onClickNegative,
      heading: t("Are you running_Liveview"),
      content: t("Upgrade your plan_Liveview"),
      LButton: t("Stay"),
      RButton: t("Go to Fleet Plan"),
      titleClassName: classes.modalTitle,
      className: classes.exceedModalRoot,
      contentClassName: classes.exceedModalContentDiv,
      RButtonClassName: classes.btn,
      LButtonClassName: classes.btn,
      actionClassName: classes.btnWrap
    });
  });
  _exports.LiveViewExceedModal = LiveViewExceedModal;
});